import { render, staticRenderFns } from "./DiscoveryItem.vue?vue&type=template&id=6c114a00&scoped=true&"
import script from "./DiscoveryItem.vue?vue&type=script&lang=js&"
export * from "./DiscoveryItem.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryItem.vue?vue&type=style&index=0&id=6c114a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c114a00",
  null
  
)

export default component.exports